import { Link } from "react-router-dom";
import { useLanguage } from '../../context/LanguageContext';
import { valouseTranslations } from '../../translations/valouseTranslations';
import { sanitizeHTML } from '../../utils/sanitize';

const TestimonialsSection = () => {
  const { language } = useLanguage();
  const t = (obj) => obj[language] || obj['fr'];
  const tr = valouseTranslations;

  return (
    <section id="temoignages" className="py-16 sm:py-24 px-6 bg-[#F3E5CF]">
      <div className="max-w-2xl mx-auto text-center space-y-8 text-[#3F2A24]">
        
        {/* Premium micro-heading structure */}
        <div className="space-y-3">
          <p className="text-[10px] sm:text-xs tracking-[0.3em] uppercase text-[#C5A059]">
            {t(tr.testimonials.contextLine)}
          </p>
          <h2 
            className="font-serif text-2xl sm:text-3xl md:text-4xl text-[#3F2A24]"
            style={{ textWrap: 'balance' }}
          >
            {t(tr.testimonials.title)}
          </h2>
          <p 
            className="font-serif text-sm sm:text-base text-[#3F2A24]/70 italic"
            style={{ textWrap: 'balance' }}
          >
            {t(tr.testimonials.poeticLine)}
          </p>
        </div>
        
        <div className="w-16 h-[1px] bg-[#C5A059]/40 mx-auto" />
        
        <p 
          className="text-base sm:text-lg leading-[1.9]"
          style={{ textWrap: 'balance' }}
          dangerouslySetInnerHTML={sanitizeHTML(t(tr.testimonials.intro))}
        />
        
        <div className="space-y-6 text-sm sm:text-base italic leading-[1.9]">
          {tr.testimonials.quotes.map((quote, index) => (
            <p key={index} style={{ textWrap: 'balance' }}>
              « {t(quote.text)} »
              <br />
              <span className="text-[#C5A059] not-italic text-xs">— {quote.author}</span>
            </p>
          ))}
        </div>
        
        <div className="pt-6">
          <Link
            to="/valouse/temoignages"
            className="inline-flex items-center justify-center px-8 py-3 rounded-full bg-[#C5A059] text-[#3F2A24] text-xs tracking-[0.2em] uppercase hover:bg-[#bdb7a7] transition-colors min-h-[48px]"
            data-testid="discover-testimonials-btn"
          >
            {t(tr.testimonials.button)}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
